import styled from 'styled-components';
import { applyEllipsis } from '../../mixins';
import { applyInputStyles } from './Input.mixins';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Input/Input');

/**
 * Base input.
 */
export var Input = /*#__PURE__*/styled.input.withConfig({
  componentId: "plasma__sc-s1s7bj-0"
})(["", " ", ""], applyInputStyles, applyEllipsis);